import React from "react";

const TradeDocumentEmptyState = (props) => {
  return (
    <div className='emptyState'>
      <i className="materialIcon --large">move_to_inbox</i>
      <small className="byline">{props.message}</small>
    </div>
  );
}

export default TradeDocumentEmptyState;



// WEBPACK FOOTER //
// ./src/features/trade_documents/components/TradeDocumentEmptyState.js